import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import { useImages } from '../context/ImageContext';

const CompareAlert1ToBayAlarmPage: React.FC = () => {
  const { getImage } = useImages();
  const pendantImage = getImage('compare-alert1-bay-alarm-mobile-medical-alert-pendant.jpg');
  
  // Reason icons
  const savingsIcon = getImage('compare-alert1-savings-icon.jpg');
  const responseIcon = getImage('compare-alert1-response-icon.jpg');
  const buttonPushIcon = getImage('compare-alert1-button-push-icon.jpg');
  const monthlyPlanIcon = getImage('compare-alert1-monthly-plan-icon.jpg');
  const helpIcon = getImage('compare-alert1-help-icon.jpg');
  const grandmotherImage = getImage('compare-alert1-grandmother-granddaughter.png');
  const womanOnStairsImage = getImage('compare-alert1-woman-on-stairs.png');

  return (
    <div className="compare-alert1-to-bay-alarm-page compare-alert1-to-life-alert-page">
      {/* Hero Section */}
      <section className="compare-hero-new">
        <div className="compare-hero-container">
          <div className="compare-hero-image">
            <div className="circular-image-wrapper">
              {pendantImage ? (
                <img 
                  src={pendantImage} 
                  alt="Mobile medical alert pendant" 
                  className="circular-image"
                />
              ) : (
                <div className="circular-image-placeholder" />
              )}
            </div>
          </div>
          
          <div className="compare-hero-content">
            <h1>Alert1 vs Bay Alarm Medical</h1>
            <h2 className="compare-hero-subtitle">No Contracts, Free Equipment, & Save BIG with our Annual Plans!</h2>
            
            <p className="compare-hero-text">
              Comparing Bay Alarm Medical to Alert1? If you are choosing a medical alert provider and want the best price 
              with 24/7/365 monitoring you can trust, the clear choice is Alert1.
            </p>
            
            <p className="compare-hero-text">
              Whether you are looking for a device with fall detection, a system that works on-the-go with built-in GPS, 
              or a combination of in-home and mobile solutions, we have a variety of alert systems to suit your needs.
            </p>
            
            <p className="compare-hero-text">
              If you're looking for a less expensive alternative to Bay Alarm Medical, you are not alone. Many seniors and their 
              families call and tell us they are looking for a more affordable medical alert system. Alert1 offers the latest 
              medical alert systems for the best price. We are confident you will find Alert1 has transparent, affordable pricing 
              and industry-leading customer service. We have been keeping our members safe and independent for 37 years!
            </p>
            
            <div style={{ textAlign: 'center', marginTop: '2rem' }}>
              <Link to="/medical-alerts" className="btn btn-primary compare-hero-btn">
                VIEW SYSTEMS
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Comparison Table Section */}
      <section className="comparison-section">
        <div className="container">
          <h2>Alert1 vs Bay Alarm Medical Costs At a Glance</h2>
          <p className="section-subtitle">
            See how Alert1 compares to Bay Alarm Medical on pricing and terms.
          </p>
          
          <div className="comparison-table-wrapper">
            <table className="comparison-table">
              <thead>
                <tr>
                  <th></th>
                  <th className="highlight-col">Alert1</th>
                  <th>Bay Alarm</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><strong>Prices Starting At</strong></td>
                  <td className="highlight-col">$19.95/mo<sup>1</sup></td>
                  <td>$24.95/mo<sup>2</sup></td>
                </tr>
                <tr>
                  <td><strong>No Long-Term Contract Required</strong></td>
                  <td className="highlight-col">✓</td>
                  <td>✓</td>
                </tr>
                <tr>
                  <td><strong>Nationwide Coverage</strong></td>
                  <td className="highlight-col">✓</td>
                  <td>✓</td>
                </tr>
                <tr>
                  <td><strong>UL Listed</strong><br /><small>Monitoring center</small></td>
                  <td className="highlight-col">✓</td>
                  <td>✓</td>
                </tr>
                <tr>
                  <td><strong>BBB Accredited Business</strong><br /><small>A+ rating from the Better Business Bureau</small></td>
                  <td className="highlight-col">✓</td>
                  <td>Unknown</td>
                </tr>
                <tr>
                  <td><strong>Constant Care</strong><br /><small>We stay on the phone until help arrives</small></td>
                  <td className="highlight-col">✓</td>
                  <td>✓</td>
                </tr>
                <tr>
                  <td><strong>Multilingual Protection</strong><br /><small>Responders speak 190 different languages</small></td>
                  <td className="highlight-col">✓</td>
                  <td>Not Listed</td>
                </tr>
                <tr>
                  <td><strong>Same Day Shipping</strong><br /><small>For 85% or more of orders</small></td>
                  <td className="highlight-col">✓</td>
                  <td>✓</td>
                </tr>
                <tr>
                  <td><strong>Unlimited Button Pushes</strong><br /><small>Never charges for pushing your button</small></td>
                  <td className="highlight-col">✓</td>
                  <td>✓</td>
                </tr>
                <tr>
                  <td><strong>Equipment Free to Use</strong><br /><small>On most devices</small></td>
                  <td className="highlight-col">✓</td>
                  <td>No</td>
                </tr>
                <tr>
                  <td><strong>TMA 5 Diamond Certified Command Center</strong><br /><small>Ensures that each center meets only the highest standards</small></td>
                  <td className="highlight-col">✓</td>
                  <td>✓</td>
                </tr>
                <tr>
                  <td><strong>Modern Senior Magazine<sup>*</sup></strong><br /><small>#1 Rated Medical Alert System</small></td>
                  <td className="highlight-col">✓</td>
                  <td>No</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="table-footnote">
            <sup>1</sup>Disclaimer: All information, prices, and data was last verified. 
            To report any incorrect or outdated information, please get in touch with us. For more information 
            on Alert1's features and costs, check out our <Link to="/pricing">pricing page</Link>.
          </div>
        </div>
      </section>

      {/* 5 Reasons Section */}
      <section className="reasons-section" style={{ background: '#f9f9f9' }}>
        <div className="container">
          <h2>5 Reasons Why Alert1 is the Best Bay Alarm Medical Alert Alternative</h2>
          
          <div className="reasons-list">
            <div className="reason-item">
              <div className="reason-icon">
                {savingsIcon && (
                  <img src={savingsIcon} alt="Value" />
                )}
              </div>
              <div className="reason-content">
                <h4><span className="reason-number">1.</span> Value</h4>
                <p>
                  We don't charge equipment fees for our medical alerts; Bay Alarm does.
                </p>
              </div>
            </div>

            <div className="reason-item">
              <div className="reason-icon">
                {responseIcon && (
                  <img src={responseIcon} alt="Support" />
                )}
              </div>
              <div className="reason-content">
                <h4><span className="reason-number">2.</span> Support</h4>
                <p>
                  Once a member sends an alert, our emergency response team stays on the line with them until help 
                  arrives (not all companies do this).
                </p>
              </div>
            </div>

            <div className="reason-item">
              <div className="reason-icon">
                {buttonPushIcon && (
                  <img src={buttonPushIcon} alt="Transparency" />
                )}
              </div>
              <div className="reason-content">
                <h4><span className="reason-number">3.</span> Transparency</h4>
                <p>
                  Alert1 does not charge our members for "false alarms" or multiple emergency button-pushes 
                  (some other companies do).
                </p>
              </div>
            </div>

            <div className="reason-item">
              <div className="reason-icon">
                {monthlyPlanIcon && (
                  <img src={monthlyPlanIcon} alt="Flexibility" />
                )}
              </div>
              <div className="reason-content">
                <h4><span className="reason-number">4.</span> Flexibility</h4>
                <p>
                  We provide monthly service plan options so no one is "locked in," as well as discounted annual plans 
                  (some of our competitors only offer multi-year plans). Alert1 has no long term contracts.
                </p>
              </div>
            </div>

            <div className="reason-item">
              <div className="reason-icon">
                {helpIcon && (
                  <img src={helpIcon} alt="Service" />
                )}
              </div>
              <div className="reason-content">
                <h4><span className="reason-number">5.</span> Service</h4>
                <p>
                  Our emergency Command Centers are staffed by trained agents who are available 24/7/365 
                  (professional responders are always standing by).
                </p>
              </div>
            </div>
          </div>

          <div className="cta-center">
            <Link to="/medical-alerts" className="btn btn-primary">TRY US TODAY</Link>
          </div>
        </div>
      </section>

      {/* Alternative Section */}
      <section className="alternative-section">
        <div className="container">
          <div className="value-content-wrapper" style={{ marginTop: '3rem' }}>
            <div className="value-image">
              <div className="circular-image-wrapper">
                {grandmotherImage ? (
                  <img 
                    src={grandmotherImage} 
                    alt="Grandmother and granddaughter" 
                    className="circular-image"
                  />
                ) : (
                  <div className="circular-image-placeholder" />
                )}
              </div>
            </div>
            
            <h2>Can Bay Alarm Medical Match Alert1's Systems and Services?</h2>
            
            <p className="section-intro">
              When you are researching medical alert systems for yourself or a loved one, there are many factors to consider. 
              Cost and the length of the contract are two of the most important ones. Alert1 offers affordable medical alert 
              systems, flexible plans, and no equipment fees. Bay Alarm does charge equipment fees.
            </p>
            
            <p className="section-intro">
              Alert1 offers monthly payment plans without long-term contracts, giving you the flexibility to cancel at any time by returning the equipment (refunds are not offered on discounted long-term plans except as in our policy). 
              Other companies often require you to commit for up to 36 months. Alert1 also offers discounted annual plans that 
              help you save money. We recommend an "apples to apples" comparison when evaluating Alert1 versus Bay Alarm Medical.
            </p>
            
            <p className="section-intro">
              Selecting an Alert1 system is easy. You can choose a mobile or home-only device, and you can add fall detection 
              for optimal safety. We recommend fall detection for all of our members. When comparing Alert1 to Bay Alarm Medical, 
              we encourage you to review comparable systems.
            </p>
            
            <div style={{ textAlign: 'center', marginTop: '2rem', clear: 'left' }}>
              <Link to="/medical-alerts" className="btn btn-primary">VIEW SYSTEMS</Link>
            </div>
          </div>
        </div>
      </section>

      {/* Ready to Try Section */}
      <section className="alternative-section" style={{ background: 'white' }}>
        <div className="container">
          <div className="value-content-wrapper" style={{ marginTop: '3rem' }}>
            <div className="value-image">
              <div className="circular-image-wrapper">
                {womanOnStairsImage ? (
                  <img 
                    src={womanOnStairsImage} 
                    alt="Woman on stairs" 
                    className="circular-image"
                  />
                ) : (
                  <div className="circular-image-placeholder" />
                )}
              </div>
            </div>
            
            <h2>Are You Ready to Try Alert1?</h2>
            
            <p className="section-intro">
              We'd love you or your loved one to be our next valued member! You can easily order your new medical alarm service{' '}
              <Link to="/medical-alerts" style={{ color: '#0066cc', textDecoration: 'underline' }}>right here</Link>
              {' '}on our website, or give us a call and one of our New Member Specialists will be happy to answer any questions you may have and assist you in obtaining the security, protection, and peace of mind you'll get from an Alert1 personal emergency alarm button.
            </p>
            
            <p className="section-intro">
              We even ship our medical alert systems via FedEx Express 2 Day Shipping. In fact, 85% of our orders are shipped out on the same day the order is placed. We hope you'll agree that when it comes to benefits and overall value, no other medical alert system provider compares to Alert1!
            </p>
            
            <div style={{ textAlign: 'center', marginTop: '2rem', clear: 'left' }}>
              <Link to="/medical-alerts" className="btn btn-primary">VIEW SYSTEMS</Link>
            </div>
          </div>
          
          <div className="table-footnote" style={{ marginTop: '3rem', clear: 'both' }}>
            <p>*Pricing of Alert1 annual service plans. Cost depends on plan and options selected. Pricing is based on standard rates, temporary promotions may apply, offers subject to change.</p>
            <p>*Bay Alarm Medical website accessed on 12/28/2022. Bay Alarm Medical is a subsidiary of Bay Alarm Company.</p>
            <p>*Medical alert comparisons and pricing are based on standard rates, temporary promotions may apply, offers subject to change. View our competitive advertising guidelines.</p>
            <p>*If you would like to request any changes to the information provided here, contact marketing@alert1.com</p>
            <p>*Alert1 and Modern Senior Magazine are wholly owned by ResponseLINK, LLC.</p>
            <p>*Please note that for all comparisons a lack of a check mark indicates that the competitor criteria is not listed on the competitor's official website.</p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CompareAlert1ToBayAlarmPage;
